import { render } from "./Login.vue?vue&type=template&id=48569642&scoped=true"
import script from "./Login.vue?vue&type=script&lang=js"
export * from "./Login.vue?vue&type=script&lang=js"

import "./Login.vue?vue&type=style&index=0&id=48569642&scoped=true&lang=css"

import exportComponent from "/Volumes/directory/IdeaProjects/Macau-Double-Color-Ball/Macau-Double-Color-Ball_Web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48569642"]])

export default __exports__